import React from 'react';
import { StupidSalesWidget } from '../widget/StupidSalesWidget';
import './WidgetTest.css';

const WidgetTest = () => {
  const testConfig = {
    apiKey: "ss_7b2e5d9f-a834-4c1d-b592-e8f6c3a45678",
    companyId: "92bd4670-4769-4ebf-9988-b41db881aae6",
    domain: "nineam-alex-landingpage.onrender.com",
    backendUrl: "https://video-embed-backend-dev.onrender.com",
    theme: {
      primaryColor: '#FF5733',
      primaryHoverColor: '#E64D2E',
      spinnerColor: '#FF5733'
    }
  };

  return (
    <div className="widget-test-container">
      <div className="test-controls">
        <h1>Widget Test Page</h1>
        
        <div className="selected-key-info">
          <h3>Test Configuration:</h3>
          <pre>
            {JSON.stringify(testConfig, null, 2)}
          </pre>
        </div>

        <div className="integration-code">
          <h3>Integration Code</h3>
          <pre>
{`<script src="${window.location.origin}/stupid-sales-widget.min.js"></script>
<div id="widget-container"></div>
<script>
  StupidSalesWidget.init('#widget-container', {
    apiKey: "${testConfig.apiKey}",
    companyId: "${testConfig.companyId}",
    backendUrl: "${testConfig.backendUrl}",
    domain: "${testConfig.domain}",
    theme: {
      primaryColor: '${testConfig.theme.primaryColor}',
      primaryHoverColor: '${testConfig.theme.primaryHoverColor}',
      spinnerColor: '${testConfig.theme.spinnerColor}'
    }
  });
</script>`}
          </pre>
        </div>
      </div>

      <div className="widget-preview">
        <h2>Widget Preview</h2>
        <div className="widget-container">
          <StupidSalesWidget config={testConfig} />
        </div>
      </div>
    </div>
  );
};

export default WidgetTest; 